//material-ui
import Container from "@mui/material/Container";

//local
import TopBar from "./TopBar";
import Router from "../router";
import NavDrawer from "./NavDrawer";
import { useAppSelector } from "../hooks/reduxHooks";

interface LayoutProps {
	applyUpdate: () => void;
	setClientSet: (v: boolean) => void;
}

const Layout = (props: LayoutProps) => {
	const { applyUpdate, setClientSet } = props;
	const playAlarm = useAppSelector((state) => state.layout.playAlarm);

	return (
		<>
			<TopBar>
				<NavDrawer applyUpdate={applyUpdate} />
			</TopBar>

			<Container maxWidth={false} sx={{ padding: "8px", backgroundColor: playAlarm ? "red" : "", minHeight: "calc(100vh - 64px)" }}>
				<main>
					<Router setClientSet={setClientSet} />
				</main>
			</Container>
		</>
	);
};
export default Layout;
